import { PromotedCourse, PromotedCourseDocument } from '~/types/simulator/simulator'
import { fromFirestore, toFirestore } from './converter'
import { FirestoreDataConverter } from 'firebase/firestore'

export const promotedCourseConverter: FirestoreDataConverter<
    PromotedCourse,
    PromotedCourseDocument
> = {
    fromFirestore,
    toFirestore,
}
